import MyModal from '../../../components/Modal';
import { WorkplaceChangingStatusType, UpdateWorkplaceStatusType } from '../types';
import { Dispatch, SetStateAction } from 'react';

interface ChangeStatusModalInterface {
  workplaceChanginStatus: WorkplaceChangingStatusType;
  setChangeStatusModalShow: Dispatch<SetStateAction<boolean>>;
  updateWorkplaceStatus: ({ id, active }: UpdateWorkplaceStatusType) => void;
  changeStatusModalShow: boolean;
}

export default function ChangeStatusModal({
  workplaceChanginStatus,
  setChangeStatusModalShow,
  updateWorkplaceStatus,
  changeStatusModalShow,
}: ChangeStatusModalInterface) {
  return (
    <MyModal
      title={workplaceChanginStatus.active ? `Inativar local ${workplaceChanginStatus.name}` : `Reativar local ${workplaceChanginStatus.name}`}
      closeButtonLabel="Cancelar"
      actionButtonLabel={workplaceChanginStatus.active ? 'Inativar' : 'Reativar'}
      modalBody={(
        <div>
          {workplaceChanginStatus.active ? 'Tem certeza que deseja inativar o local' : 'Tem certeza que deseja reativar o local'}
          {' '}
          <strong>{workplaceChanginStatus.name}</strong>
          {' '}
          ?
        </div>
      )}
      onClose={() => setChangeStatusModalShow(false)}
      onAction={() => updateWorkplaceStatus({
        id: workplaceChanginStatus.id,
        active: !workplaceChanginStatus.active,
      })}
      show={changeStatusModalShow}
      type={workplaceChanginStatus.active ? 'suspendAction' : 'activateAction'}
    />
  );
}
